import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import { useInternationalWireForm } from "./InternationalWire.form";

import type { ReactLocalization } from "@fluent/react";
import type Account from "../../../../Account";
import type { InternationalWireForm } from "./InternationalWire.form";
import type { UseFormReturn } from "react-hook-form";

type InternationalWireFormReturnType = UseFormReturn<InternationalWireForm>;

const InternationalWireContext = createContext<InternationalWireFormReturnType>(
  {} as InternationalWireFormReturnType,
);
export const useInternationalWireContext = () =>
  useContext(InternationalWireContext);

export const InternationalWireFormProvider = ({
  children,
  accounts = [],
  l10n,
}: {
  children: ReactNode;
  accounts?: Account[];
  l10n?: ReactLocalization;
}) => {
  const validAccounts = accounts.filter(
    (a: Account) => a.isInternal() && a.isValidTransferSource(),
  );
  const internationalWireForm = useInternationalWireForm(validAccounts, l10n);
  return (
    <InternationalWireContext.Provider value={{ ...internationalWireForm }}>
      {children}
    </InternationalWireContext.Provider>
  );
};
